'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { BlogSearchSubmittedProps, TrackingFunction } from '../types';

export const useBlogSearchTracking = (
  props: BlogSearchSubmittedProps,
  autoTrack: boolean = false,
): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.BLOG_SEARCH_SUBMITTED,
      properties: props,
    },
    autoTrack,
  );
};
